import CustomIcon from "./customIcon";
import AnalyticsTracking from "@helpers/analyticsTracking";
import ShowPlacePopup from "./showPlacePopup";
import { select } from "@utils/function";

export default function AddTwitsToMap({ dataTwitsID, clickType }) {
  HQ.Properties.highlights?.map((obj) => {
    if (obj.id === +dataTwitsID) {
      const {
        id,
        icon,
        color,
        color_front,
        color_outline,
        latitude,
        longitude,
        html,
        zoom_min,
        name_tracking,
      } = obj;

      const videoID = window["resultsPlaces"]
        .filter(({ icon }) => icon === "icon-video")
        .map(({ id }) => id);

      checkIfHiglightsChecked(videoID[0]);

      if (window[`marker-${dataTwitsID}`] === undefined) {
        let options = {};

        if (icon === "icon-twitter" || icon === "icon-x") {
          options = { minWidth: 319, maxWidth: 319 };
        }

        if (icon === "icon-video") {
          options = { minWidth: 282 };
        }

        window[`marker-${dataTwitsID}`] = L.marker([latitude, longitude], {
          icon: CustomIcon({
            id,
            icon,
            color,
            color_front,
            color_outline,
          }),
        })
          .addTo(map)
          .bindPopup(html, options)
          .on("click", function (e) {
            // const { lat, lng } = e.latlng;
            AnalyticsTracking("clickPlace", {
              name: name_tracking,
              icon,
              icon_shortcode: null,
              description: "click",
            });
          })
          .on("popupopen", function (e) {
            setTimeout(() => {
              AnalyticsTracking("clickHighlight", {
                name: name_tracking,
                icon,
                icon_shortcode: null,
                description: "",
              });
            }, 1000);
          })
          .on("popupclose", function (e) {
            document.body.dataset.tweetOpened = "";
          })
          .openPopup();

        // console.log("videoID", videoID);

        // console.log("dataTwitsID 1", dataTwitsID);

        window[`marker-${dataTwitsID}`].addTo(window[`video-${videoID[0]}`]);

        document.body.dataset.tweetOpened = dataTwitsID;
      } else {
        // console.log("dataTwitsID 2", dataTwitsID);

        // --------------------------------------------------
        const curentZoom = map.getZoom();

        let checkPlayes = false;

        // if zoom_min is set and current zoom is less than zoom_min
        if (zoom_min && curentZoom < zoom_min) {
          map.setZoom(zoom_min ?? 18);
          // map.panTo([latitude, longitude]);
          // map.setView([latitude, longitude], zoom_min ?? 18, {
          //   animation: true,
          // });

          setTimeout(() => {
            checkMarker(dataTwitsID, checkPlayes);
          }, 500);
        } else {
          checkMarker(dataTwitsID, checkPlayes);
        }

        // --------------------------------------------------

        // when popupclose remove dataset.tweetOpened
        map.on("popupclose", function (e) {
          document.body.dataset.tweetOpened = "";
        });
      }
    }
  });
}

/**
 * Check if marker exist
 * on map and open popup
 *
 * @param {number} dataTwitsID
 * @param {boolean} checkPlayes
 */
function checkMarker(dataTwitsID, checkPlayes) {
  return map.eachLayer((layer) => {
    if (layer instanceof L.Marker) {
      const checkIfMarkerExistOnMap = L.DomUtil.hasClass(
        layer.options.icon.options,
        `place-${dataTwitsID}`
      );
      if (checkIfMarkerExistOnMap && !checkPlayes) {
        document.body.dataset.tweetOpened = dataTwitsID;
        layer.openPopup();
        checkPlayes = true;
      }
    }
  });
}

/**
 * Check if highlights checkbox is
 * checked in information settings
 *
 * @param {number} videoID
 */
function checkIfHiglightsChecked(videoID) {
  const checkboxCheckInInformationSettings = select(`#checkbox-${videoID}`);

  // check if checkbox is checked
  if (checkboxCheckInInformationSettings.checked) return;

  checkboxCheckInInformationSettings.checked = true;
  checkboxCheckInInformationSettings.click();
}
